import { cn } from "design-system/utils"
import { useTranslation } from "react-i18next"

type Props = {
  isSyncing: boolean
}

export const SyncIndicator = ({ isSyncing }: Props) => {
  const { t } = useTranslation()

  return (
    <div className="pointer-events-none sticky top-14 z-40 -mx-6 -mt-6 mb-2 h-0 shrink-0">
      <div
        role="status"
        className={cn(
          "absolute inset-x-0 top-0 h-px overflow-hidden transition-opacity duration-300",
          isSyncing ? "opacity-100 delay-200" : "opacity-0",
        )}
      >
        {isSyncing && (
          <>
            <span className="sr-only">{t("dashboard.updating")}</span>
            <div className="h-full w-1/4 animate-indeterminate bg-linear-to-r from-transparent via-chart-1 to-transparent motion-reduce:w-full motion-reduce:animate-none" />
          </>
        )}
      </div>
    </div>
  )
}
